import { useMsal } from '@azure/msal-react'
import {
  Avatar,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
} from '@fluentui/react-components'
import { SignOutRegular } from '@fluentui/react-icons'
import { useUserProfile } from '@/app/UserProfileContext'
import styles from './UserProfile.module.css'

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/)
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

export function UserProfile() {
  const { instance, accounts } = useMsal()
  const account = accounts[0]
  const { firstName, displayName: graphName, photoUrl } = useUserProfile()

  if (!account) return null

  const displayName = graphName || account.name || account.username
  const initials = getInitials(displayName)

  const handleSignOut = () => {
    void instance.logoutPopup({ postLogoutRedirectUri: window.location.origin })
  }

  return (
    <Menu>
      <MenuTrigger disableButtonEnhancement>
        <button type="button" className={styles.trigger} aria-label={`Cont: ${displayName}`}>
          <Avatar
            name={displayName}
            initials={initials}
            image={photoUrl ? { src: photoUrl } : undefined}
            size={32}
            color="colorful"
          />
          <span className={styles.name}>{firstName || displayName}</span>
        </button>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          <MenuItem icon={<SignOutRegular />} onClick={handleSignOut}>
            Deconectare
          </MenuItem>
        </MenuList>
      </MenuPopover>
    </Menu>
  )
}
